import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XL, LG, MD } from '@zendeskgarden/react-typography';
import { ItemCol, ItemRow } from './CompanyFoundation.styles.js';
import {  
   Diamond,
   PieChart,
   ClipBoard,
  } from 'svg/svgIcons';

const CompanyFoundation = (props) => {
  return (
    <div style={{margin: '0 auto', maxWidth: '1200px'}}>
      <Row>
        <Col size="12" style={{marginBottom: '40px'}}>
          <div>
            <XL bold  style={{margin: '0 auto', maxWidth: '700px'}} center paddingTopLg navy tag="h2">Trust, Industry Experience, Communication and Customer Success</XL>
            <LG center style={{margin: '0 auto', maxWidth: '500px'}} paddingTopMd paddingBottomLg navy light tag="h3">We uphold our end and exceed expectations  because what really matters is the patient.</LG>
          </div>
        </Col>
      </Row>
      
      <ItemRow>
        <ItemCol size="12" md={6}>
          <div>
            {/*<div style={{height: '50px'}}>
              <Diamond width="50px" height="40px" />
            </div>*/}
            <MD uppercase paddingTopMd semibold blue tag="h3">Trust</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">We know equipment projects are large investments and many times the focal point of your practice. We take pride in fulfilling our role and leading your team towards the completion of that investment. After one phone call you will know that you can trust us to get the job done right. We take that trust seriously.</MD>

          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            {/*<div style={{height: '50px'}}>
              <PieChart width="45px" height="45px" />
            </div>*/}
            <MD uppercase paddingTopMd semibold blue tag="h3">Industry Expereince</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Our owner installed the first super-conducting whole-body imaging magnet in this hemisphere. Building on that experience, MRT has identified and partnered with the best engineers, minds and personnel in the business. We’ve been around since the beginning and helped develop the technologies and practices used today, who better to handle your project? 
            </MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={6}>
          <div>
            {/*<div style={{height: '50px'}}>
              <ClipBoard width="43px" height="43px" />
            </div>*/}
            <MD uppercase paddingTopMd semibold blue tag="h3">Communication</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Transparency in communication is key. No matter the situation, good or bad, we pick up the phone. You will never have trouble getting a hold of us and we will keep you informed every step of the way. You have our word.</MD>
          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            {/*<div style={{height: '50px'}}>
              <ClipBoard width="43px" height="43px" />
            </div>*/}
            <MD uppercase paddingTopMd semibold blue tag="h3">Customer Success</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Our exceptional reputation is a direct reflection of our customers’ success. After providing first-class equipment, project management and service to our customers they strengthen their communities, care for patients and improve the health and minds of the people around them.</MD>
          </div>
        </ItemCol>

      </ItemRow>
    </div>
  )
}


export default CompanyFoundation;
